import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { logOut } from "../../store/auth/authActions";
import getId from "../../../utils/getId";
import { SubmitHandler, useForm } from "react-hook-form";
import { post } from "../../api";
import { USER_EDIT_DATA_URL } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";
import { setSuccessMessage } from "../../store/alerts/alertsActions";
import FormInput from "../../../utils/FormInput";
import { phoneValidator } from "../../../utils/formsValidation";
import { useNavigate } from "react-router";
import ConsentInputs from "../FinalizePage/ConsentInputs/ConsentInputs";
import EAModal from "../shared/Modal/EAModal";

type Inputs = {
  firstName: string;
  lastName: string;
  phone: string;
  acceptEAktywni: boolean;
};

const UserDataValidator: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const facilityIds = useFacility();
  const userData = useSelector((state: State) => state.auth.userData);
  const [isAccountCompleted, setIsAccountCompleted] = useState(true);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm<Inputs>({
    defaultValues: {
      firstName: userData.firstName || "",
      lastName: userData.lastName || "",
      phone: userData.phone || "",
      acceptEAktywni: userData.agreement || userData.agreementRegulamin || false,
    },
  });

  const handleEditUserData: SubmitHandler<Inputs> = async ({ firstName, lastName, phone, acceptEAktywni }: Inputs) => {
    const { isError } = await post(USER_EDIT_DATA_URL(facilityIds), {
      ...userData,
      firstName,
      lastName,
      phone,
      agreement: acceptEAktywni,
      agreementRegulamin: acceptEAktywni,
    });
    if (!isError) {
      dispatch(setSuccessMessage(t("operacja_przebiegla_pomyslnie")));
      navigate(0);
    }
  };

  useEffect(() => {
    const additionalValidationFacilityIds = ["123", "123"]; // SZTYWNIAK DLA KRAKOWA, WALIDACJA PO AGREEMANTACH
    if (
      getId(userData) &&
      (!userData.firstName ||
        !userData.lastName ||
        (additionalValidationFacilityIds.includes(facilityIds) &&
          (!userData.agreement || !userData.agreementRegulamin)))
    ) {
      setIsAccountCompleted(false);
    } else {
      setIsAccountCompleted(true);
    }
    //eslint-disable-next-line
  }, [userData]);

  return (
    <>
      {!isAccountCompleted && (
        <EAModal
          // footer={true}
          isOpen={!isAccountCompleted}
          onClose={() => dispatch(logOut())}
          title={t("uzupelnij_dane_konta")}
          onAccept={handleSubmit(handleEditUserData)}
        >
          <form onSubmit={handleSubmit(handleEditUserData)}>
            {" "}
            <FormInput
              type={"text"}
              name={"firstName"}
              text={t("imie")}
              register={{ ...register("firstName", { required: true }) }}
              errors={errors}
              isLabel
            />
            <FormInput
              type={"text"}
              name={"lastName"}
              text={t("nazwisko")}
              register={{ ...register("lastName", { required: true }) }}
              errors={errors}
              isLabel
            />{" "}
            <FormInput
              type={"number"}
              name={"phone"}
              text={t("telefon_kontaktowy")}
              register={{ ...register("phone", { ...phoneValidator(true) }) }}
              errors={errors}
              isLabel
            />
            <ConsentInputs errors={errors} control={control} setValue={setValue}       newsletter={true} />
          </form>
        </EAModal>
      )}
    </>
  );
};

export default UserDataValidator;
